import React, { useEffect, useState } from "react";
import Sidemenu from "../../components/sidemenu";
import Header from "../../components/header";
import styles from "./styles/practice.module.scss";
import addicon from "../../images/add.svg";
import { useNavigate } from "react-router-dom";
import { Switch } from "antd";
import { functionService } from "../../lib/functions";
const ListPracticeTest = () => {
   const [test, setTest] = useState();
   const navigate = useNavigate();
   const getAllTest = async () => {
      const response = await functionService.get("practice/get-all-test");
      setTest(response?.response?.data?.meta?.data);
   };
   useEffect(() => {
      getAllTest();
   }, []);
   const visibilityChange = async (id,visibility) => {
      const response = await functionService.get(`practice/delete-level/${id}?visibility=${visibility}`);
      if (response.status) {
         const response = await functionService.get("practice/get-all-test");
         setTest(response?.response?.data?.meta?.data);
      }
   };
   return (
      <div className={styles.container}>
         <Sidemenu className={styles.side} />
         <div className={styles.side_container}>
            <Header />
            <div className={styles.side_header}>
               <p className={styles.heading}>All Practice Tests</p>
               <button
                  onClick={() => {
                     navigate("/practice-assessment-test/add");
                  }}
               >
                  <strong>+ </strong>Add new level
               </button>
            </div>
            <div className={styles.card_container}>
               {test &&
                  test.map((item) => {
                     return (
                        <div className={styles.card}>
                           <div>
                              <div>
                                 {" "}
                                 <p>Level Title : {item.level_name}</p>
                                 <p>No of Questions : {item.total_questions}</p>
                              </div>

                              <div>
                                 <p>
                                    Public :{" "}
                                    <Switch
                                       checked={item.status === "PUBLIC"}
                                    />
                                 </p>
                                 <p>
                                    Visibility :{" "}
                                    <Switch
                                       checked={item.is_active}
                                       onChange={(e) => {
                                          visibilityChange(item.id,e);
                                       }}
                                    />
                                 </p>
                              </div>
                           </div>
                           <button
                              onClick={() => {
                                 navigate(
                                    `/practice-assessment-test/edit/${item.id}`
                                 );
                              }}
                           >
                              Edit
                           </button>
                        </div>
                     );
                  })}
            </div>
         </div>
      </div>
   );
};

export default ListPracticeTest;
